export class ReportArea {
  code: string;
  name: string;
  icon?: string;
  description: string;
  isHidden: false;
  permissions?: string[];
}
